import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Restaurants from './pages/Restaurants';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import About from './pages/About';
import Contact from './pages/Contact';
import Cities from './pages/Cities';
import CityDetail from './pages/CityDetail';
import SuccessStories from './pages/SuccessStories';
import RestaurantDetails from './pages/RestaurantDetails';
import TopRestaurants from './pages/TopRestaurants';
import RegisterRestaurant from './pages/RegisterRestaurant';
import PartnerSupport from './pages/PartnerSupport';
import Partner from './pages/Partner';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import FilterHotels from './pages/hotel/FilterHotels';

// Hotel pages imports
import Hotels from './pages/hotel/Hotels';
import HotelDetails from './pages/hotel/HotelDetails';
// import HotelSearch from './pages/hotel/HotelSearch';
import HotelBooking from './pages/hotel/HotelBooking';
import HotelConfirmation from './pages/hotel/HotelConfirmation';
// import HotelAccount from './pages/hotel/HotelAccount';
// import RegisterHotel from './pages/hotel/RegisterHotel';
// import Add from './pages/hotel/Add'; // Import the new Add component

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            {/* Existing Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/restaurants" element={<Restaurants />} />
            <Route path="/partner" element={<Partner />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/cities" element={<Cities />} />
            <Route path="/restaurants/:id" element={<RestaurantDetails />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/top-restaurants" element={<TopRestaurants />} />
            <Route path="/city/:cityName" element={<CityDetail />} />
            <Route path="/success-stories" element={<SuccessStories />} />
            <Route path="/register-restaurant" element={<RegisterRestaurant />} />
            <Route path="/partner-support" element={<PartnerSupport />} />

            {/* Hotel Routes */}
 <Route path="/hotels" element={<Hotels />} />
            <Route path="/hotel/:id" element={<HotelDetails />} />
            <Route path="/filter" element={<FilterHotels />} />
             {/* <Route path="/hotel/search" element={<HotelSearch />} /> */}
             <Route path="/hotel/booking/:id" element={<HotelBooking />} /> 
            <Route path="/hotel/confirmation/:bookingId" element={<HotelConfirmation />} />
            {/* <Route path="/hotel/account" element={<HotelAccount />} />
            <Route path="/hotel/register" element={<RegisterHotel />} />
            <Route path="/hotel/add" element={<Add />} />       */}
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;